import React from 'react';
import { motion } from 'framer-motion';
import { Star, Folder, Paperclip } from 'lucide-react';
const testimonials = [{
  initials: 'MG',
  name: 'María G.',
  location: 'Buenos Aires',
  text: 'En 3 días de aplicar el Sistema Anti-ATS recibí 2 llamados. Llevaba 4 meses mandando CVs sin respuesta. No lo podía creer.',
  color: 'bg-electric'
}, {
  initials: 'LP',
  name: 'Lucas P.',
  location: 'Córdoba',
  text: 'Los scripts de entrevista del Tomo 5 me dieron confianza real. Entré preparado, negocié el sueldo y acepté la oferta que yo quería.',
  color: 'bg-energy'
}, {
  initials: 'RM',
  name: 'Romina M.',
  location: 'Rosario',
  text: 'Pasé de cero respuestas a 4 entrevistas en 2 semanas. El método funciona. Solo hay que ejecutarlo.',
  color: 'bg-gold'
}];
export function Testimonials() {
  return <section className="pt-4 pb-8 border-b border-petroleum bg-graphite/50" data-id="element-658">
      <div className="container mx-auto px-4" data-id="element-659">
        {/* Social Proof Header */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="mb-6 flex justify-center" data-id="element-660">
          <div className="inline-flex items-center gap-4 md:gap-6 bg-petroleum/80 backdrop-blur-sm border border-electric/20 rounded-full pl-3 pr-5 md:pl-4 md:pr-7 py-2.5 md:py-3 shadow-lg shadow-electric/5" data-id="element-661">
            {/* Avatars */}
            <div className="flex -space-x-2.5" data-id="element-662">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-gradient-to-br from-electric/30 to-petroleum border-2 border-petroleum flex items-center justify-center text-[11px] md:text-xs font-bold text-white" data-id="element-663">
                  {String.fromCharCode(64 + i)}
                </div>)}
            </div>

            {/* Divider */}
            <span className="w-px h-8 md:h-9 bg-gradient-to-b from-transparent via-electric/30 to-transparent" data-id="element-664"></span>

            {/* Rating */}
            <div className="flex flex-col items-start leading-tight" data-id="element-665">
              <div className="flex items-center gap-1.5" data-id="element-666">
                <div className="flex gap-0.5 text-gold" data-id="element-667">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-gold" data-id="element-668" />)}
                </div>
                <span className="text-white font-bold text-sm md:text-base" data-id="element-669">
                  4.9
                </span>
                <span className="text-textsecondary text-xs md:text-sm" data-id="element-670">
                  /5
                </span>
              </div>
              <span className="text-[10px] md:text-xs text-textsecondary mt-0.5" data-id="element-671">
                <span className="text-electric font-semibold" data-id="element-672">+500</span>{' '}
                personas ya consiguieron entrevistas
              </span>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-4 mt-6" data-id="element-673">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-cardbg border border-electric/10 rounded-xl p-5 hover:border-electric/30 transition-colors relative mt-3" data-id="element-674">
              {/* Card Folder Tab */}
              <div className="absolute -top-3 left-4 z-20" data-id="element-675">
                <div className="bg-petroleum border border-electric/30 rounded-t-md px-2 py-0.5 flex items-center gap-1 transform -rotate-2" data-id="element-676">
                  <Folder className="w-2.5 h-2.5 text-textsecondary" data-id="element-677" />
                  <span className="text-[9px] font-mono font-bold uppercase tracking-widest text-textsecondary" data-id="element-678">
                    Recomendación #0{i + 1}
                  </span>
                </div>
              </div>

              {/* Paperclip */}
              <div className="absolute -top-2 -left-2 z-20 transform -rotate-45 text-textsecondary/40" data-id="element-679">
                <Paperclip className="w-5 h-5" data-id="element-680" />
              </div>

              {/* Stamp */}
              <div className="absolute bottom-4 right-4 z-20 pointer-events-none select-none" style={{
            transform: 'rotate(-10deg)'
          }} data-id="element-681">
                <div className="border-2 border-gold/40 rounded px-2 py-0.5" data-id="element-682">
                  <span className="text-gold/50 font-extrabold tracking-widest text-[10px] uppercase" data-id="element-683">
                    Contratado
                  </span>
                </div>
              </div>

              {/* Ruled-paper lines */}
              <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{
            backgroundImage: 'repeating-linear-gradient(0deg, #ffffff 0px, #ffffff 1px, transparent 1px, transparent 24px)'
          }} data-id="element-684"></div>

              <div className="flex items-center gap-4 mb-3 relative z-10" data-id="element-685">
                <div className={`w-12 h-12 rounded-full ${t.color} flex items-center justify-center text-graphite font-bold text-lg`} data-id="element-686">
                  {t.initials}
                </div>
                <div data-id="element-687">
                  <div className="flex gap-1 mb-1" data-id="element-688">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-gold fill-gold" data-id="element-689" />)}
                  </div>
                  <div className="text-sm text-textsecondary" data-id="element-690">
                    <span className="text-white font-medium" data-id="element-691">{t.name}</span> •{' '}
                    {t.location}
                  </div>
                </div>
              </div>
              <p className="text-textsecondary italic" data-id="element-692">"{t.text}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}